import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({ prefix: 'cr-' });

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
